module.exports = __webpack_public_path__ + "static/media/img3-2.cf43aa45.png";